import { useStore } from "vuex";

/**
 * Vérification des permissions et rôles de l'utilisateur connecté.
 * L'interface masque ce qui n'est pas autorisé ; l'API reste la seule autorité (contrôle côté serveur).
 */
export const usePermissions = () => {
  const store = useStore();

  const can = (permission) => store.getters["auth/hasPermission"](permission);
  const canAny = (permissions) => store.getters["auth/hasAnyPermission"](permissions);
  const hasRole = (role) => store.getters["auth/hasRole"](role);

  return {
    can,
    canAny,
    hasRole,
    hasPermission: can,
  };
};
